import axios from 'axios'

/**
 * @function blockToggleGet Used to toggle the blocked state of any item
 * @param {string} jwt - the JWT token of the user (accessed through UserContext)
 * @param {string} paramStr - the query param string representing the item and item id to block/unblock (eg. "group?group={id}")
 * @returns {Promise} Promise object represents
 */

export const blockToggleGet = (jwt, paramStr) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_ADMIN_URL}/admin/api/${paramStr}`,
        {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        }
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err))
  })
}
